module.exports = __webpack_public_path__ + "img/92204.7af3da4b.svg";